<template lang="pug">
	div.container-fluid
		.card
			.card-header
				span.fa.fa-search.mr-2
				| Buscar propuestas
			.card-body
				.row
					.col-xs-12.col-sm-12.col-md-4.col-lg-4.col-xl-4
						.form-group(v-if="permisos.agenda_comercial_consultar_todos")
							label Usuario
							input.form-control(placeholder="Usuario que la crea", v-model="filtro.usuario", @keypress.enter="buscar")
						.form-group
							label Cliente
							input.form-control(placeholder="Escribe el cliente al que se le presenta", v-model="filtro.cliente", @keypress.enter="buscar")
					.col-xs-12.col-sm-12.col-md-4.col-lg-4.col-xl-4
						.form-group
							label Título
							input.form-control(placeholder="Escribe el título por el que buscar", v-model="filtro.titulo", @keypress.enter="buscar")
						.form-group
							.row
								.col
									.form-group
										label Desde
										.input-group
											datepicker(
												:language='$dateLang'
												:bootstrap-styling="true"
												v-model="filtro.fechaIni"
												@closed="buscar"
												:monday-first="true"
											)
											.input-group-append
												button.btn.btn-danger(@click="delFechaIni")
													span.fa.fa-trash
								.col
									.form-group
										label Hasta
										.input-group
											datepicker(
												:language='$dateLang'
												:bootstrap-styling="true"
												v-model="filtro.fechaFin"
												@closed="buscar"
												:monday-first="true"
											)
											.input-group-append
												button.btn.btn-danger(@click="delFechaFin")
													span.fa.fa-trash
					.col-xs-12.col-sm-12.col-md-4.col-lg-4.col-xl-4
						.form-group
							label Tipo
							br
							.btn-group
								button.btn.btn-sm(:class="(filtro.tipo === 'todas') ? 'btn-primary' : ''", @click="setTipo('todas')") Todas
								button.btn.btn-sm(:class="(filtro.tipo === 'personalizadas') ? 'btn-primary' : ''", @click="setTipo('personalizadas')") Personalizadas
								button.btn.btn-sm(:class="(filtro.tipo === 'plantillas') ? 'btn-primary' : ''", @click="setTipo('plantillas')") Plantillas
						
						.form-group
							label Estado
							br
							.btn-group
								button.btn.btn-sm(:class="(filtro.estado === 'todas') ? 'btn-primary' : ''", @click="setEstado('todas')") Todos
								button.btn.btn-sm(:class="(filtro.estado === 'presentadas') ? 'btn-primary' : ''", @click="setEstado('presentadas')") Presentadas
								button.btn.btn-sm(:class="(filtro.estado === 'aprobadas') ? 'btn-primary' : ''", @click="setEstado('aprobadas')") Aprobadas
								button.btn.btn-sm(:class="(filtro.estado === 'rechazadas') ? 'btn-primary' : ''", @click="setEstado('rechazadas')") Rechazadas
			.card-footer
				button.btn.btn-sm.btn-primary(@click="buscar")
					span.fa.fa-search.mr-2
					| Buscar
				button.btn.btn-sm.btn-warning.ml-2(@click="nuevaPropuesta")
					span.fa.fa-edit.mr-2
					| Nueva propuesta
		
		editor-propuesta(v-if="ID_propuesta", :id-propuesta="ID_propuesta", :id-agente="usuario.ID", @cerrar="ID_propuesta = null")
						
		.card.mt-2
			.card-header
				span.fa.fa-list.mr-2
				| Resultados
			div.table-responsive.mb-0
				table.table.table-striped.mb-0
					thead.bg-dark.text-white
						tr
							th Usuario
							th Empresa
							th Cliente
							th Fecha
							th Tiulo
							th Importe
							th Estado
							th Resultado
							th
					tbody
						tr(v-for="propuesta in listado", :key="propuesta.ID_propuesta")
							td {{propuesta.usuarioInfo}}
							td {{propuesta.empresaNombreFiscal}}
							td {{propuesta.clienteInfo}}
							td {{propuesta.fecha_creada | moment('DD-MM-YYYY')}}
							td {{propuesta.titulo}}
							td {{propuesta.importe | currency('€')}}
							td 
								span(v-if="propuesta.fecha_rechazada") Rechazada
								span(v-else-if="propuesta.fecha_decision")
									span.text-success(v-if="propuesta.decision === 'aprobada'") Aprobada
									span.text-danger(v-else) Rechazada
								span(v-else-if="propuesta.fecha_presentada") Presentada
								span(v-else) No presentada
							td
								div.btn-group(v-if="!propuesta.decision && propuesta.fecha_presentada && propuesta.entrada_ID_asociada")
									button.btn.btn-success.btn-sm(@click="aprobar(propuesta)")
										span.fa.fa-check.mr-2
										| Aprobada
									button.btn.btn-danger.btn-sm(@click="rechazar(propuesta)")
										span.fa.fa-ban.mr-2
										| Rechazada
								
							td
								button.btn.btn-sm.btn-primary(@click="ID_propuesta = propuesta.ID_propuesta")
									span.fa.fa-eye
</template>


<script>
import { mapGetters } from 'vuex'
import EditorPropuesta from './editor-propuestas'
import axios from 'axios'

export default {
	components: {
		'editor-propuesta': EditorPropuesta
	},
	data () {
		return {
			ID_propuesta: null,
			filtro: {
				usuario: '',
				cliente: '',
				titulo: '',
				fechaIni: new Date(new Date().getTime() - 2592000000), // Propuestas de hace un mes
				fechaFin: null,
				tipo: 'todas',
				estado: 'todas'
			},
			listado: []
		}
	},
	computed: {
		...mapGetters({
			'permisos': 'permisos/permisos',
			'usuario': 'session/usuario'
		})
	},

	created () {
		this.buscar()
	},

	methods: {
		nuevaPropuesta () {
			this.ID_propuesta = 'nueva'
		},
		buscar () {
			const form = JSON.parse(JSON.stringify(this.filtro))
			form.fechaIni = (this.filtro.fechaIni) ? Math.floor(this.filtro.fechaIni.getTime() / 1000) : null
			form.fechaFin = (this.filtro.fechaFin) ? Math.floor(this.filtro.fechaFin.getTime() / 1000) : null
			axios.post('/agenda-comercial/php/api/busca-propuestas.php', form)
				.then(res => {
					this.listado = res.data.propuestas
				})
				.catch(this.$responseError)
		},

		delFechaIni () {
			this.filtro.fechaIni = null
			this.buscar()
		},

		delFechaFin () {
			this.filtro.fechaFin = null
			this.buscar()
		},

		setTipo (tipo) {
			this.filtro.tipo = tipo
			this.buscar()
		},

		setEstado (estado) {
			this.filtro.estado = estado
			this.buscar()
		},

		aprobar (propuesta) {
			const form = {
				entrada_ID: propuesta.entrada_ID_asociada,
				propuesta_ID: propuesta.ID_propuesta,
				decision: 'aprobada'
			}
			this.$store.commit('alertas/confirm', {
				titulo: 'Aprobar propuesta',
				mensaje: `¿Quieres aprobar esta propuesta?`,
				callback: acepta => {
					if (acepta) {
						this.$http.post('agenda-comercial/php/api/set-propuesta-decision.php', form)
							.then(res => {
								this.buscar()
							})
							.catch(e => {
								this.$store.commit('alertas/error', {
									titulo: 'Error',
									mensaje: e.response.data.error
								})
							})
					}
				}
			})
		},

		rechazar (propuesta) {
			const form = {
				entrada_ID: propuesta.entrada_ID_asociada,
				propuesta_ID: propuesta.ID_propuesta,
				decision: 'rechazada'
			}
			this.$store.commit('alertas/confirm', {
				titulo: 'Rechazar propuesta',
				mensaje: `¿Quieres rechazar esta propuesta?`,
				callback: acepta => {
					if (acepta) {
						this.$http.post('agenda-comercial/php/api/set-propuesta-decision.php', form)
							.then(res => {
								this.buscar()
							})
							.catch(e => {
								this.$store.commit('alertas/error', {
									titulo: 'Error',
									mensaje: e.response.data.error
								})
							})
					}
				}
			})
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/modulos/agenda-comercial/vue/componentes/propuestas/listado-propuestas.vue